export default "__VITE_ASSET__7543f623__"